import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { ExcelexportService } from '../excelexport.service';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-cuadrante-parking',
  templateUrl: './cuadrante-parking.component.html',
  styleUrls: ['./cuadrante-parking.component.scss']
})
export class CuadranteParkingComponent implements OnInit {

  datos: any[] = [];
  categorias: any[] = [];
  employes: any[] = ['Juan', 'Asun', 'Tere', 'Damian', 'José'];

  turnos: any[] = [];
  turno_selected: any = {
    'alias' : '',
    'color' : 'lightgray'
  };

  mes_actual: number = 0;

  meses = [
    {
      'id': 1,
      'mes' : 'Enero'
    },
    {
      'id': 2,
      'mes' : 'Febrero'
    },
    {
      'id': 3,
      'mes' : 'Marzo'
    },
    {
      'id': 4,
      'mes' : 'Abril'
    },
    {
      'id': 5,
      'mes' : 'Mayo'
    },
    {
      'id': 6,
      'mes' : 'Junio'
    },
    {
      'id': 7,
      'mes' : 'Julio'
    },
    {
      'id': 8,
      'mes' : 'Agosto'
    },
    {
      'id': 9,
      'mes' : 'Septiembre'
    },
    {
      'id': 10,
      'mes' : 'Octubre'
    },
    {
      'id': 11,
      'mes' : 'Noviembre'
    },
    {
      'id': 12,
      'mes' : 'Diciembre'
    }
  ];
  parking = [
    {
      'id' : '1',
      'nombre' : 'Jose María Buck'
    },
    {
      'id' : '2',
      'nombre' : 'Av. Novelda'
    },
    {
      'id' : '25',
      'nombre' : 'Canalejas'
    },
    {
      'id' : '26',
      'nombre' : 'Navas'
    },
    {
      'id' : '27',
      'nombre' : 'Gorrion'
    },
    {
      'id' : '0',
      'nombre' : 'OFICINA ELCHE'
    },
    {
      'id' : '62',
      'nombre' : 'PARKING ELCHE'
    },
    {
      'id' : '63',
      'nombre' : 'PARKINGS DE ELCHE'
    }
  ];

  parking_id;

  check: boolean = false;

  month = 0;

  yearsList: any[] = [];
  year:string = '0';

  deleteMode: boolean = false;

  estados = [
    {
        "title": "REG. CORRECTO (&lt; 15min)",
        "description": "CUMPLE EL TURNO PERFECTAMENTE (&lt; 15min)",
        "color": "lightgreen"
    },
    {
        "title": "FALTA DE PUNTUALIDAD (15min&lt;registro&lt;60min)",
        "description": "MAS DE 15 MINUTOS DE RETRASO Y MENOS DE 60 MINUTOS",
        "color": "tomato"
    },
    {
        "title": "IMPUNTUALIDAD EXCESIVA (60min &lt; registro)",
        "description": "\"MAS DE 60 MINUTOS DE RETRASO O TURNO MAL ASIGNADO",
        "color": "yellow"
    },
    {
        "title": "REG. EDITADO AUTOMATICAMENTE (registro &lt; 15min)",
        "description": "FALTABA UN REGISTRO Y SE HA COMPLETADO AUTOM\u00c1TICAMENTE",
        "color": "#4f47ff"
    },
    {
        "title": "REG. EDITADO POR CLIENTE",
        "description": "REGISTRO EDITADO O INSERTADO POR EL USUARIO",
        "color": "#9300c9"
    },
    {
        "title": "REGISTRO EDITADO POR ADMIN",
        "description": "REG. EDITADO POR ADMIN",
        "color": "white"
    },
    {
        "title": ">NO EXISTE REG. O EL REG. FUE CREADO CON IMPUNTUALIDAD (15min &lt; registro)",
        "description": "REGISTRO EDITADO POR ADMIN",
        "color": "black"
    }
  ];

  constructor(
    public rest: RestService,
    private excel: ExcelexportService,
    public user: UserService) {
    let d = new Date();
    this.month = this.meses[d.getMonth()].id;
    this.mes_actual = this.meses[d.getMonth()].id;
    this.parking_id = this.user.parking_id;
    this.year = ''+d.getFullYear();
  }

  ngOnInit() {
    console.log(this.year);
    this.getEstados();
  }

  getEstados(){
    this.rest.getEstadosCuadranteParking().subscribe(
      (data) => this.estados = data['data']);
  }

  exportAsXLSX(): void {

    Swal.fire({ title: 'Cargando', text: 'Espere por favor', icon: 'question' });
    Swal.showLoading();

    let nameXls;
    nameXls = this.GetNameParking(this.parking_id);

    this.rest.GetReportXLS(this.month, this.parking_id,this.year).subscribe((data) => {

      Swal.close();
      this.excel.exportCuadranteWithTotal(
        data['data']['detalle'],
        data['data']['total'],
        'Informe Parking ' + nameXls[0].nombre +'_' + this.year +'-' + this.month); 
    },(er) => {
      Swal.close();
      this.user.ErrorSwal(er);
    });

  }

  ShowObservations(d){
    if( !d.observations ){ return false; }
    
    Swal.fire({
      icon: 'info',
      title: 'Observaciones',
      width: '90%',
      html: d.observations
    });
  }

  CreateObservations(day){
    Swal.fire({
      title: 'Escriba la observación',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      showLoaderOnConfirm: true,
      preConfirm: (data) => {
        console.log(data);
        this.rest.GuardarObservacion(data,day.fecha,this.parking_id)
        .subscribe(
          (data)=> {},
          (er) => {
            Swal.showValidationMessage(
              `Request failed: ${er.error.data}`
            );
          });
        
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        this.user.SuccessSwal('OBSERVACION','DATOS GUARDADOS');
        this.GetData();
      }
    })
  }

  GetNameParking(parkingId){
    return this.parking.filter( (parking) => parking.id === parkingId);
  }

  GetYears(){

    this.rest.getYearsCentro(this.parking_id).subscribe( (data) => {
      this.yearsList = data['data'];
    },
    error => {
      this.user.ErrorSwal(error);
    } );
  }

  Info(){
    if( this.yearsList.length === 0){
      Swal.fire(
        {
          title: 'INFORMACION',
          text: 'Selecciona un parking y un mes y se habilitará esta casilla para seleccionar los años disponibles',
          icon: 'info',
          confirmButtonText: 'OK'
      });
    }
    
  }

  resetTurno(){
    this.turno_selected = {
      'alias' : '',
      'color' : 'lightgray'
    };
  }

  GetData() {
    if ( this.parking_id === undefined || this.parking_id === null || !this.parking_id ) {
      return Swal.fire({title: 'ERROR',text: 'Selecciona un parking', icon: 'error', confirmButtonText: 'OK' }); 
    }
    if ( this.year === '0' ) { return Swal.fire({title: 'ERROR',text: 'Selecciona un año', icon: 'error', confirmButtonText: 'OK' }); }
    if ( this.month === 0 ) { return Swal.fire({title: 'ERROR',text: 'Selecciona un mes', icon: 'error', confirmButtonText: 'OK' }); }

    Swal.fire({ title: 'Cargando', text: 'Espere por favor', icon: 'question' });
    Swal.showLoading();

    this.GetTurnos();
      this.rest.GetCuadranteParking(this.month, this.parking_id,this.year).subscribe(
        (data) => {
          this.resetTurno();
          Swal.close();
          this.datos = data['data']['data'];
          this.employes = data['data']['employes'];
      }, (error) => {
          Swal.close();
        this.datos = [];      
        this.user.ErrorSwal(error);
        this.user.loading = false;
      });
  }

  Changes(index, index2, datos) {

    if ( this.deleteMode ) {
      const opcion = confirm('Estas seguro de borrar este dia ?');
      if ( opcion ) {
        this.DeleteApi(this.datos[index]['valor'][index2]['id_datos']);
        this.datos[index]['valor'][index2] = this.BorradoDia();
      }
    } else {

      const d = new Date();

      if ( this.month === 0 || this.turno_selected.alias === '' ) {
        alert('Comprueba Mes y turno seleccionado');
      } else {

        const newDate = new Date(this.year + '-' + this.month + '-' + datos.dia);

        this.datos[index].valor[index2] = this.turno_selected;

        this.rest.PostChangesParking(
          this.user.formatDate(newDate),
          this.employes[index2].id,
          this.datos[index].valor[index2].id
        ).subscribe(
          (data) => {},
          (er) => {
            Swal.fire({
              title: 'TURNO DUPLICADO',
              text: er.error.data,
              icon: 'error',
              confirmButtonText: 'OK'
            });
          });

      }

    }


  }

  BorradoDia() {
    return {
      "alias": null,
      "color": null,
      "color_entrada": "lightgreen",
      "color_salida": "lightgreen",
      "entrada": null,
      "id": null,
      "id_datos": null,
      "nombre": null,
      "salida": null,
      "visible": null,
    };
  }

  DeleteApi(id_datos) {
    this.rest.DeleteDay(this.parking_id, id_datos)
    .subscribe( (data) => {
      this.user.loading = false;
    },
    error => {
      this.user.loading = false;
    } );
  }

  GetTurnos() {
    this.rest.getTurnosParking(this.parking_id).subscribe( (data) => {
      this.turnos = data['data'];
      this.user.loading = false;
    },
    error => {
      this.user.PublicError(error);
      setTimeout(() => this.user.loading = false, 500);
    } );
  }

  DeleteMode() {
    if ( !this.deleteMode ) {
      this.turno_selected = {
        'alias' : 'MODO BORRADO',
        'color' : 'red'
      };
    } else {
      this.turno_selected = {
        'alias' : '',
        'color' : 'lightgray'
      };
    }

    this.deleteMode = !this.deleteMode;

  }

  SelectTurno(turno){ this.turno_selected = turno; }
}
